module.exports = __webpack_public_path__ + "start-d443e819b6248a54c6eb466c75938306.png";